// Audit API — GET /audit/ via the shared apiService (never raw axios/fetch).

import { apiService } from "src/services";
import { IAuditPage, IAuditQuery } from "../models/interfaces";
import { IEnvelope, unwrap } from "src/utils/kcc";

// GET /audit/ — paginated, newest-first activity log. Trailing slash matches
// the backend route (avoids a 307 under CORS).
export const getAuditLogs = async (query: IAuditQuery = {}): Promise<IAuditPage> => {
	const params: Record<string, unknown> = {
		page: query.page ?? 1,
		page_size: query.page_size ?? 20,
	};
	if (query.search) params.search = query.search;
	if (query.include_system) params.include_system = true;
	const res = await apiService.get<IEnvelope<IAuditPage>>("/audit/", params);
	return unwrap<IAuditPage>(res);
};
